var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"font-size":"2em"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('qtychange',{attrs:{"changer":_vm.changer,"changee":_vm.changee,"qtychange":"qtyreduce","clctto":"_out"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9220c9cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qtychange/qtyreduce.vue
// module id = null
// module chunks = 